const carouselResponsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1200 },
    items: 5,
  },
  laptop: {
    breakpoint: { max: 1200, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 450 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 450, min: 0 },
    items: 1,
  },
}

export const trainersConfig = {
  carouselResponsive,
}
